<template>
  <div style="margin-top: 30px;">
    <el-container>
      <el-card style="position: fixed;border-radius: 8px" :body-style="{padding:'0px'}">
        <el-aside width="150px">
          <el-menu v-for="(item, index) in tagList" :key="item.id" :default-active="localTag" @select="onSelect"
                   style="margin-top: 0;">
            <el-menu-item class="title" :index="item.name" route="">{{ item.name }}</el-menu-item>
          </el-menu>
        </el-aside>
      </el-card>
      <div style="margin-left: 210px;display: flex;flex-direction: column;width: 100%">
        <el-card :body-style="{padding:'0px'}" style="border-radius: 8px">
          <el-collapse>
            <el-collapse-item :title="'当前地域：' + localArea" name="1" style="padding-left: 40px;padding-right: 15px">
              <ol class="area-list" v-for="(item, index) in areasList">
                <li :class="localAreaId === item.id ? 'area_text' : 'area_text_non'"
                    v-on:click="onAreaClick(item.id,item.name)">
                  {{ item.name }}
                </li>
              </ol>
            </el-collapse-item>
          </el-collapse>
        </el-card>
        <el-card style="margin-top: 20px; border-radius: 8px;width: 100%" :body-style="{padding:'0px'}">
          <div v-for="(item, index) in zxList">
            <a :title="item.title" target="_blank" v-on:click="toArticle(item)">
              <div :class="index % 2 === 0 ? 'info_title' : 'info_title2'">
                <h3 v-if="item.show_top_data === 1" style="margin-left: 20px;color: darkred">{{
                    "[置顶] " + item.title
                  }}</h3>
                <h3 v-if="item.show_top_data === 0" style="margin-left: 20px;color: #333333">{{ item.title }}</h3>
                <div style="color: #666666;margin-left: auto">{{ item.created_at }}</div>
              </div>
            </a>
          </div>
        </el-card>
      </div>
    </el-container>
    <div style="display: flex;flex-direction: column;align-items: center;margin-top: 50px">
      <el-pagination
        background
        :current-page="localNum"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="500">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {api_info_article, info_main, upload_read_num} from "../../networks/InfoArticleHandler";

export default {
  data() {
    return {
      zxList: [],
      tagList: [],
      localTag: '公考资讯',
      localNum: 1,
      localArea: '全国',
      localAreaId: 6,
      areasList: [],
    }
  },
  created: function () {
    this.getData(0)
  },
  methods: {
    getData: function (index) {
      var context = this;
      var promise = info_main(true);
      promise.then(function (r) {
        context.tagList = r.categories;
        context.areasList = r.areas;
        context.zxList = context.tagList[index].articles
      }).catch(function (error) {
      });
    },
    getArticleList: function (category_id, pageNum) {
      var context = this;
      var promise = api_info_article(category_id, pageNum, context.localAreaId);
      promise.then(function (r) {
        context.zxList = r.articles;
        var doc = document.body.scrollTop == 0 ? $(document.documentElement) : $('body');
        doc.animate({'scrollTop': 0});
      }).catch(function (error) {
      });
    },
    onSelect: function (index, indexPath) {
      let context = this;
      context.localTag = index;
      context.localNum = 1;
      var index = context.tagList.findIndex(item => item.name === index)
      context.getArticleList(context.tagList[index].id, 1)
    },
    handleCurrentChange: function (currentPage) {
      let context = this;
      context.localNum = currentPage;
      var index = context.tagList.findIndex(item => item.name === context.localTag)
      context.getArticleList(context.tagList[index].id, currentPage)
    },
    onAreaClick: function (id, name) {
      let context = this;
      this.localArea = name;
      this.localAreaId = id;
      this.localNum = 1;
      var index = context.tagList.findIndex(item => item.name === context.localTag);
      this.getArticleList(context.tagList[index].id, this.localNum)
    },
    toArticle: function (item) {
      upload_read_num(item.id)
      window.open(item.short_url, '_blank')
    }
  }
};
</script>

<style>

.el-aside {
  color: #333;
  text-align: center;
}

.title {
  font-weight: normal;
  border-bottom: 1px #f2f2f2 solid;
}

.info_title {
  background-color: #ffffff;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title2 {
  background-color: #f8f8f8;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.area-list {
  float: left;
  padding: 0;
  padding-right: 10px;
  list-style: none;
}

.area_text_non {
  width: 50px;
  text-align: center;
}

.area_text {
  font-weight: bold;
  width: 50px;
  text-align: center;
  color: #ffbc42;
}


</style>



// WEBPACK FOOTER //
// src/components/Layout/infomation.vue